export function print_duration(start: number) {
    const totalSeconds = (Date.now() - start) / 1000
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds - hours * 3600 - minutes * 60

    const strHours = (hours < 10 ? '0' : '') + hours
    const strMinutes = (minutes < 10 ? '0' : '') + minutes
    const strSeconds = (seconds < 10 ? '0' : '') + seconds

    console.log(['duration', `${strHours}:${strMinutes}:${strSeconds}`])
}
